import PropTypes from 'prop-types'
import React from 'react'
import InfoIcon from '@mui/icons-material/Info'

const Info = ({ className }) => <InfoIcon className={className} />

export default Info

Info.propTypes = {
  className: PropTypes.string
}
